import { render, staticRenderFns } from "./CatalogProduct.vue?vue&type=template&id=aed0e878&"
import script from "./CatalogProduct.vue?vue&type=script&lang=js&"
export * from "./CatalogProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports